import PropTypes from "prop-types";
import { Table } from "semantic-ui-react";

// Shared 6-column tracking row table used by both tracking previews: the per-company preview
// (company-profile/preview-import/tracking-preview.jsx) and the multi-client preview
// (components/tracking/tracking-preview.jsx). Keeps the row markup in one place.
const TrackingRowsTable = ({ rows }) => (
  <Table celled>
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell>Invoice Number</Table.HeaderCell>
        <Table.HeaderCell>Sales Order Number</Table.HeaderCell>
        <Table.HeaderCell>Ship Date</Table.HeaderCell>
        <Table.HeaderCell>Tracking</Table.HeaderCell>
        <Table.HeaderCell>Carrier</Table.HeaderCell>
        <Table.HeaderCell>Item ID</Table.HeaderCell>
      </Table.Row>
    </Table.Header>
    <Table.Body>
      {(rows ?? []).map((y, index) => (
        <Table.Row key={index}>
          <Table.Cell>{y.invoice_number}</Table.Cell>
          <Table.Cell>{y.sales_order_number}</Table.Cell>
          <Table.Cell>{y.ship_date}</Table.Cell>
          <Table.Cell>{y.tracking_number}</Table.Cell>
          <Table.Cell>{y.carrier}</Table.Cell>
          <Table.Cell>{y.item_id}</Table.Cell>
        </Table.Row>
      ))}
    </Table.Body>
  </Table>
);

TrackingRowsTable.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.object),
};

export default TrackingRowsTable;
